import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "../utils/Loader";
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
  Snackbar,
  Link,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import DescriptionIcon from "@material-ui/icons/Description";
import FileUpload from "../utils/FileUpload";
import Constants from "../../common/constants";
import ServicesContext from "../../contexts/servicesContext";

const noBenefitsId = "100";
const dormitoryCost = 35000;

const useStyles = makeStyles((theme) => ({
  root: {},
  pageContent: {
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
    },
  },
}));

function DormitoryAccomodation() {
  const classes = useStyles();
  const services = useContext(ServicesContext);
  const [showSuccess, setShowSuccess] = useState(false);
  const [open, setOpen] = useState(true);

  const [loading, setLoading] = useState(true);

  const [application, setApplication] = useState(undefined);
  const [abiturStatus, setAbiturStatus] = useState(undefined);
  const [dormitoryStatus, setDormitoryStatus] = useState(undefined);
  const [dormStatus, setDormStatus] = useState(undefined);

  const [benefits, setBenefits] = useState([]);
  const [selectedBenefit, setSelectedBenefit] = useState("");

  // Документ, подтверждающий наличие льготы
  const [confirmationDocumentId, setConfirmationDocumentId] = useState([]);
  const [confirmationDocumentPath, setConfirmationDocumentPath] = useState([
    "",
  ]);

  const [dormQueue, setDormQueue] = useState(null);

  // Паспорт вакцинации
  // const [vaccinationPassportId, setVaccinationPassportId] = useState("");
  // const [vaccinationPassportPath, setVaccinationPassportPath] = useState("");

  const handleSelectedBenefitChange = (event) => {
    setSelectedBenefit(event.target.value);
  };

  const handleSubmit = () => {
    // Если пользователь выбрал какую-то льготу, но не зарузил подтверждающий документ,
    // то пользователь не сможет засабмитить форму
    if (selectedBenefit !== noBenefitsId && !confirmationDocumentId) {
      alert("Загрузите подтверждающий документ");
    } else {
      if (application) {
        services.dormAccomodation
          .updateDormApplication(
            {
              privilegeId: selectedBenefit,
              privilegeProofId: confirmationDocumentId || null,
            },
            application?.id
          )
          .then(() => {
            fetchData();
            setShowSuccess(true);
            setOpen(true);
          })
          .catch((error) => {
            console.error(error);
            alert("При отправке запроса произошла ошибка");
          });
      } else {
        services.dormAccomodation
          .submitDormApplication({
            privilegeId: selectedBenefit,
            privilegeProofId: confirmationDocumentId || null,
            // vaccinationPassportId: vaccinationPassportId || null,
          })
          .then(() => {
            fetchData();
            setShowSuccess(true);
            setOpen(true);
          })
          .catch((error) => {
            console.error(error);
            alert("При отправке запроса произошла ошибка");
          });
      }
    }
  };

  const fetchData = async () => {
    setLoading(true);

    const userId = services.auth.getCurrentUser().id;
    services.secretary
      .getAbiturStatus(userId)
      .then((response) => setAbiturStatus(response.data))
      .catch((error) => {
        setAbiturStatus(null);
      });

    services.secretary
      .getEntStatus(userId)
      .then((response) => setDormitoryStatus(response.data))
      .catch((error) => {
        setDormitoryStatus(null);
      });

    services.dormAccomodation
      .getBenefits()
      .then((response) => setBenefits(response.data))
      .catch((error) => console.error(error.response));

    // Если в базе уже есть application, то значит там лежит и статус
    services.dormAccomodation
      .getApplication()
      .then((response) => {
        setApplication(response.data);
      })
      .then(() => {
        services.dormAccomodation
          .getDormStatus()
          .then((response) => {
            setDormStatus(response.data);
          })
          .catch((error) => {
            setDormStatus(null);
          });
      })
      .catch((error) => {
        setApplication(null);
        setDormStatus(null);
      });
  };

  useEffect(() => {
    fetchData();
  }, [services]);

  useEffect(() => {
    if (
      benefits.length &&
      application !== undefined &&
      abiturStatus !== undefined &&
      dormStatus !== undefined
    ) {
      setLoading(false);
    }
  }, [benefits, application, abiturStatus, dormStatus]);

  useEffect(() => {
    // if application !== null && application !== undefined
    if (application) {
      setSelectedBenefit(`${application.privilege?.id}`);
      setConfirmationDocumentId([]);
      setConfirmationDocumentPath([]);
      Object.keys(application.privilegeProof).map((i) => {
        setConfirmationDocumentId((confirmationDocumentId) => [
          ...confirmationDocumentId,
          application.privilegeProof[i].id,
        ]);
        setConfirmationDocumentPath((confirmationDocumentPath) => [
          ...confirmationDocumentPath,
          "/Подтверждающий документ " + i,
        ]);
      });


      services.dormAccomodation
        .getDormQueue()
        .then((response) => {
          setDormQueue(response.data);
        })
        .catch((error) => {
          setDormQueue(null);
        });
      // setVaccinationPassportId(`${application.vaccinationPassport?.id}`);
      // setVaccinationPassportPath(application.vaccinationPassport?.path);
    }
  }, [application]);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setShowSuccess(false);
  }

  // useEffect(() => {
  //   if (confirmationDocumentId) {
  //     Object.keys(confirmationDocumentId).map((i) =>
  //       setConfirmationDocumentPath((confirmationDocumentPath) => [
  //         ...confirmationDocumentPath,
  //         "/Подтверждающий документ " + i,
  //       ])
  //     );
  //     for (let i = 1; i < confirmationDocumentId.length + 1; i++) {
  //       setConfirmationDocumentPath((confirmationDocumentPath) => [
  //         ...confirmationDocumentPath,
  //         "/Подтверждающий документ " + i,
  //       ]);
  //     }
  //     setConfirmationDocumentPath("/Подтверждающий документ");
  //     // Заглушка, чтоб появилась кнопка загрузки документа
  //   }
  // }, [confirmationDocumentId]);

  // useEffect(() => {
  //   if (vaccinationPassportId) {
  //     setVaccinationPassportPath("/Паспорт вакцинации");
  //   }
  // }, [vaccinationPassportId]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Paper className={classes.pageContent}>
      <form className={classes.root}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={9} xl={8}>
            <Typography variant="h5">
              Подача заявления на общежитие (стоимость - {dormitoryCost} тг.)
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} xl={4} justifyContent="flex-end">
            <Link
              component="a"
              variant="body2"
              href="/files/instructions-for-applying-for-a-hostel-kaz.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "7px",
                fontSize: "15px",
              }}
            >
              <DescriptionIcon
                fontSize="small"
                style={{ marginRight: "4px" }}
              />
              Студенттер үйлерінен орын алуға өтініш беру нұсқаулығы
            </Link>
            <Link
              component="a"
              variant="body2"
              href="/files/instructions-for-applying-for-a-hostel-rus.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "15px",
              }}
            >
              <DescriptionIcon
                fontSize="small"
                style={{ marginRight: "4px" }}
              />
              Инструкция по подаче заявления на место в домах студентов
            </Link>
          </Grid>
        </Grid>

        <br />
        <Grid container justify="center" spacing={3}>
          {abiturStatus === 3 && (
            <Typography align="center" variant="h6">
              Вы не можете ничего менять на этой странице, так как вам отказали
              в поступлении
            </Typography>
          )}
          {/* Если application имеется */}
          {application !== null &&
            dormStatus &&
            application &&
            dormStatus?.id !== 1 && (
              <Grid item xs={12}>
                <div style={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'column',
                  gap: '10px',
                }}>
                  <Alert severity="info">
                    <Typography align="center" variant="h6">
                      Вы не можете повторно отправить заявку
                    </Typography>
                    <Typography align="center" variant="h6">
                      Текущий статус заявки: {dormStatus?.description}
                    </Typography>
                  </Alert>
                  {/* {dormQueue && <Alert severity="success">
                    <Typography align="center" variant="h6">
                      Ваша очередь: {dormQueue}
                    </Typography>
                  </Alert>} */}
                </div>

              </Grid>
            )}
          {dormStatus?.id === 1 && (
            <Grid item xs={12}>
              <div style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                gap: '10px',
              }}>
                <Alert severity="info">
                  <Typography align="center" variant="h6">
                    Текущий статус заявки: {dormStatus?.description}
                  </Typography>
                  <Typography align="center" variant="h6">
                    На данном этапе можно изменить льготную категорию и
                    подтверждающий документ
                  </Typography>
                </Alert>
                {dormQueue && <Alert severity="success">
                  <Typography align="center" variant="h6">
                    Ваша очередь: {dormQueue}
                  </Typography>
                </Alert>}
              </div>
            </Grid>
          )}
          {dormitoryStatus === 0 && (
            <Grid item xs={12}>
              <Alert severity="info">
                <Typography align="center" variant="h6">
                  Пожалуйста, заполните все предыдущие разделы, чтобы подать
                  заявку на общежитие
                  <br />
                </Typography>
              </Alert>
            </Grid>
          )}
          <Grid item xs={12} md={8} lg={10}>
            <Typography variant="subtitle2">
              Выберите льготную категорию:
            </Typography>
            <br />
            <FormControl component="fieldset">
              <RadioGroup
                value={selectedBenefit}
                onChange={handleSelectedBenefitChange}
                color="default"
              >
                <Grid container spacing={3}>
                  {benefits.map(({ id, privilegeDescription }) => (
                    <Grid item key={id} xs={12}>
                      <FormControlLabel
                        value={`${id}`}
                        control={<Radio color="primary" />}
                        label={id + "-категория. " + privilegeDescription}
                        disabled={
                          (dormStatus?.id === 1 &&
                            !dormitoryStatus === 0 &&
                            !application) || // Enable when dormStatus.id is 1 and either dormitoryStatus is not 0 or application is not true
                          (dormStatus?.id !== 1 &&
                            (dormitoryStatus === 0 || application)) // Disable when dormStatus.id is not 1 and either dormitoryStatus is 0 or application is true
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>
          {selectedBenefit && selectedBenefit !== noBenefitsId && (
            <Grid item xs={12} md={8} lg={10}>
              {dormStatus?.id === 1 ? (
                <>
                  <FileUpload
                    helperText="Подтверждающий документ"
                    fileType={Constants.FILE_TYPES.benefitConfirmationDocDorm}
                    file={confirmationDocumentId}
                    filePath={confirmationDocumentPath}
                    handleSetFileId={(fileId) =>
                      setConfirmationDocumentId(fileId)
                    }
                    multiple={true}
                  />
                </>
              ) : (
                <FileUpload
                  helperText="Подтверждающий документ"
                  fileType={Constants.FILE_TYPES.benefitConfirmationDocDorm}
                  file={confirmationDocumentId}
                  filePath={confirmationDocumentPath}
                  handleSetFileId={(fileId) =>
                    setConfirmationDocumentId(fileId)
                  }
                  disabled={!!application || dormitoryStatus === 0}
                  multiple={true}
                />
              )}
            </Grid>
          )}
          <Grid item xs={12} md={8} lg={10}>
            <Grid container justify="center">
              {dormStatus?.id === 1 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Изменить заявку
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  // Если abiturStatus пустой или abiturStatus !== 3 или application уже имеется
                  disabled={
                    !selectedBenefit ||
                    // !abiturStatus ||
                    // abiturStatus === 3 ||
                    dormitoryStatus === 0 ||
                    application
                  }
                >
                  Подать заявку
                </Button>
              )}
            </Grid>
          </Grid>
          {showSuccess && (
            <div>
              <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
              >
                <Alert
                  onClose={handleClose}
                  severity="success"
                  variant="filled"
                  elevation={6}
                  sx={{ width: "100%" }}
                >
                  Данные успешно сохранены!
                </Alert>
              </Snackbar>
            </div>
          )}
        </Grid>
      </form>
    </Paper >
  );
}

export default DormitoryAccomodation;
